import { Injectable } from "@angular/core";
import { LoginService } from "./login.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { firstValueFrom } from "rxjs";
import { BACKEND_URI } from "../config/config-vars";
import { MonitorType } from "../models/monitor-type.model";

const BASE_URL = `${BACKEND_URI}/api/monitorType`;
const GET_ALL_URL = BASE_URL;
const INSERT_URL = BASE_URL;
const UPDATE_URL = (id) => `${BASE_URL}/${id}`;
const GET_BY_ID_URL = (id) => `${BASE_URL}/${id}`;
const DELETE_BY_ID_URL = (id) => `${BASE_URL}/${id}`;

@Injectable({providedIn: 'root'})
export class MonitorTypeService {
    constructor(private http: HttpClient, private loginService: LoginService){}
    
    async getAll(): Promise<MonitorType[]> {
        if(this.loginService.isloggedIn) {
            return await firstValueFrom(
                this.http.get<MonitorType[]>(GET_ALL_URL)
            );
        }
    }

    async getById(id): Promise<MonitorType> {
        if(this.loginService.isloggedIn) {
            return await firstValueFrom(
                this.http.get<MonitorType>(GET_BY_ID_URL(id))
            );
        }
    }
    async create(data: MonitorType): Promise<MonitorType> {
        if(this.loginService.isloggedIn) {
            return await firstValueFrom(
                this.http.post<MonitorType>(INSERT_URL, data)
            );
        }
    }
    async update(id, data: MonitorType): Promise<MonitorType> {
        if(this.loginService.isloggedIn) {
            return await firstValueFrom(
                this.http.put<MonitorType>(UPDATE_URL(id), data)
            );
        }
    }


    async delete(id): Promise<void> {
        if(this.loginService.isloggedIn) {
            try{
                await firstValueFrom(
                    this.http.delete(DELETE_BY_ID_URL(id))
                );
            }catch(err) {}
            } 
        }      
    }